// Section for import npm components ------------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';

// Section for import custom components --------------------------------------------------------------------------------
import { AppConfigContext } from '@providers/AppConfigProvider';
import DisplayUtility from '@utils/DisplayUtility';

// import CommonUtility from '@utils/Common';

// Section for type definition -----------------------------------------------------------------------------------------
import DisplayUtilityClass from '@/types/utils/DisplayUtilityClass';

// import CommonUtilityClass from '@/types/CommonUtilityClass';
import { ScoreReviewProps } from '@/types/components/MansionDetail/MansionReviewPropsData';

// const commonUtil: CommonUtilityClass = CommonUtility;

const CustomRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#00375F',
  },
  '& .MuiRating-iconHover': {
    color: '#00375F',
  },
  '@media (max-width: 767px)': {
    '& .MuiRating-icon': {
      fontSize: '12px', // 星の大きさを指定
      paddingTop: '14.5px', // lineHeightを指定
    },
  },
  '@media (min-width: 768px)': {
    '& .MuiRating-icon': {
      fontSize: '20px', // 星の大きさを指定
    },
  },
});

// CSSの共通使用する値を設定
const label = 'p-2 bg-gray-01 text-center text-base font-bold text-rf-black';

export default function ScoreRating(props: ScoreReviewProps) {
  const { isMobile } = useContext(AppConfigContext);
  const { title, score, countViewers, isReview, categoryName } = props;

  const isCategoryTotal = categoryName === 'total';
  const isCategoryHope = categoryName === 'hope';

  const isTargetCategory = !isCategoryTotal && !isCategoryHope;
  const isEmptyReview = !isReview;
  const isDisplay = isTargetCategory && isReview;

  const displayUtility: DisplayUtilityClass = DisplayUtility;

  return (
    <Box className="md:sticky md:z-10 md:top-4">
      {isMobile ? (
        <Box>
          <Box className="flex justify-between px-5 h-10 bg-gray-01">
            <Typography variant="h3" className=" leading-10  text-left text-base font-bold text-rf-black">
              {title}
            </Typography>
            {isDisplay && (
              <Box className="flex gap-x-2">
                <CustomRating
                  name="half-rating-read"
                  defaultValue={displayUtility.formatDecimalDigitToNumber(score)}
                  precision={0.1}
                  readOnly
                />
                <Typography className="leading-10 text-rf-navy font-bold">
                  {displayUtility.formatDecimalDigitToString(score)}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      ) : (
        <Box>
          <Typography variant="h3" className={`${label}`}>
            {title}
          </Typography>
          {isDisplay && (
            <Box className="flex md:flex-wrap gap-x-8 max-md:gap-x-4 justify-center mt-6 max-md:mt-8">
              <Box className="md:flex-basis-[58%] md:max-w-full max-md:leading-10">
                <Typography className="max-md:hidden w-[86px] mx-auto mb-3 h-5 leading-5 text-xs text-center bg-gray-01 rounded-sm">
                  {countViewers}人の評価
                </Typography>
                <CustomRating
                  name="half-rating-read"
                  defaultValue={displayUtility.formatDecimalDigitToNumber(score)}
                  precision={0.1}
                  readOnly
                />
              </Box>
              <Box className="max-md:flex max-md:gap-x-5 md:flex-basis-[36%] md:max-w-full">
                <Typography className="text-5xl md:leading-[56px] max-md:text-4xl text-rf-navy font-medium">
                  {displayUtility.formatDecimalDigitToString(score)}
                </Typography>
              </Box>
            </Box>
          )}
          {isEmptyReview && (
            <Box className="mt-8 mb-16">
              <Typography className="text-2xl text-center text-rf-navy font-bold ">評価なし</Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}
